import { HttpService } from '@/api/shared/http.service'
import { ApiPagedPayload, ApiPagedResponse } from '@/api/shared/types'
import { migrateFromV1ToV4 } from '@/api/shared/utils'

import {
  NotificationApiType,
  NotificationsListPayload,
  ReadNotificationsPayload
} from './notifications.types'

class NotificationsService extends HttpService {
  getNotificationsList(params: ApiPagedPayload<NotificationsListPayload>) {
    return this.axios.get<
      ApiPagedResponse<NotificationApiType[]> & { unreadCount: number }
    >(migrateFromV1ToV4(this.getPath('/inApp')), { params })
  }

  setNotificationReadAll(params: ReadNotificationsPayload) {
    return this.axios.post<{
      count: number
    }>(this.getPath('/inApp/read'), null, { params })
  }

  setNotificationReadById({ id }: { id: string }) {
    return this.axios.put<null>(this.getPath(`/inApp/read/${id}`))
  }

  getNotificationsCount(projectId: string) {
    return this.axios.get<{
      count: number
    }>(this.getPath('/inApp/unreadCount'), {
      params: {
        projectId
      }
    })
  }
}

export const NotificationsServiceSingleton = new NotificationsService(
  'api/v1/notifications'
)
export { NotificationsServiceSingleton as NotificationsService }
